import React from "react";

export const NotFoundPage = () => {
  return (
    <div className="col-md-6 col-md-offset-3">
      <h2>404 Not Found</h2>
    </div>
  );
};
